import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBSubHeading from '../../shared/CBSubHeading';
import { withRouter } from 'react-router';
import {
  fetchWorkshops as _fetchWorkshops,
  updateWorkshop as _updateWorkshop,
} from '../../../actions/workshopActions';
import CBInputField from '../../shared/form_components/CBInputField';
import CBButtonWithIconSmall from '../../shared/CBButtonWithIconSmall';
import CBSubmitButton from '../../shared/form_components/CBSubmitButton';

class WSPredictedMaintenanceSettings extends React.Component {
  state = {
    formData: [],
    edited: false
  };

  componentDidMount = () => {
    const { fetchWorkshops, workshops, selectedWorkshopId } = this.props;
    fetchWorkshops();
  };

  handleInputChange = (index, newValue) => {
    this.setState(prevState => {
      const updatedFormData = [...prevState.formData];
      updatedFormData[index] = newValue;
      return { formData: updatedFormData, edited: true };
    });
  };

  handleAddField = () => {
    this.setState(prevState => ({
      formData: [...prevState.formData, ''],
      edited: true
    }));
  };

  handleRemoveField = (index) => {
    this.setState(prevState => {
      const updatedFormData = prevState.formData.filter((_, i) => i !== index);
      return { formData: updatedFormData, edited: true };
    });
  };

  handleSubmit = () => {
    const { updateWorkshop, selectedWorkshopId, workshops } = this.props;
    const selectedWorkshop = workshops.find((ws) => ws.id == selectedWorkshopId);
    const newSettings = {...selectedWorkshop.settings};
    const newJobList = [...this.state.formData];

    if (!newSettings.predicted_maintenances) {
      newSettings.predicted_maintenances = {
        periodic_maintenance_tasks: newJobList
      };
    } else {
      newSettings.predicted_maintenances.periodic_maintenance_tasks = newJobList;
    }

    const newWorkshop = {
      ...selectedWorkshop,
      settings: newSettings
    }

    updateWorkshop(selectedWorkshopId, newWorkshop);
    this.setState({edited: false})
  };

  componentDidUpdate(prevProps) {
    const { selectedWorkshopId, workshops } = this.props;
    const { formData, edited } = this.state;

    let selectedWorkshop = null;

    if(workshops && workshops.length > 0) {
      selectedWorkshop = workshops.find((ws) => ws.id == selectedWorkshopId)
    }

    if (!selectedWorkshop) {
      return;
    }

    let newPeriodicMaintenanceTasks = [];

    if (selectedWorkshop.settings.predicted_maintenances && selectedWorkshop.settings.predicted_maintenances.periodic_maintenance_tasks) {
      newPeriodicMaintenanceTasks = selectedWorkshop.settings.predicted_maintenances.periodic_maintenance_tasks;
    }

    if (((selectedWorkshopId !== prevProps.selectedWorkshopId) || (!prevProps.workshops || prevProps.workshops.length == 0)) || (!edited && formData.length != newPeriodicMaintenanceTasks.length) ) {
      this.setState({
        formData: newPeriodicMaintenanceTasks
      })
    }
  }

  render() {
    const {
      t,
      user,
      selectedWorkshopId,
      workshops,
    } = this.props;

    const { formData, edited } = this.state;
    const selectedWorkshop = workshops.find((ws) => ws.id == selectedWorkshopId);

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'sectionContainer')}>
              <CBSubHeading>
                {t('periodicMaintenanceTaskFields')}
              </CBSubHeading>
              <p style={{marginTop: 8}}>{t('periodicMaintenanceTaskFieldsDescription')}</p>
              <h5 style={{ marginTop: 16, color: 'white' }}><strong>{t('usageInstructions')}</strong></h5>
              <p style={{ marginTop: 8 }}>
                {t('instruction1')}
                {' '}
                {t('instruction2')}
              </p>
              <ul style={{ marginTop: 4, marginBottom: 8, paddingLeft: 24, color: 'white' }}>
                <li>{t('instruction3')}</li>
                <li>{t('instruction4')}</li>
                <li>{t('instruction5')}</li>
              </ul>
            </div>
            <div style={getStyle(screenSize, styles, 'formContainer')}>
              {formData.map((fieldValue, index) => (
                <div
                  key={index}
                  style={getStyle(screenSize, styles, 'fieldContainer')}
                >
                  <CBInputField
                    name={`field-${index}`}
                    value={fieldValue}
                    placeholder={t('fieldValue', { ns: 'common' })}
                    onChange={(e) => this.handleInputChange(index, e.value)}
                    inputStyle={getStyle(screenSize, styles, 'input')}
                    labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                  />
                  <CBButtonWithIconSmall
                    style={getStyle(screenSize, styles, 'button')}
                    onClick={() => this.handleRemoveField(index)}
                    text={t('removeField', { ns: 'common' })}
                    textStyle={getStyle(screenSize, styles, 'buttonText')}
                  />
                </div>
              ))}
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <CBButtonWithIconSmall
                  onClick={this.handleAddField}
                  text={t('addField', { ns: 'common' })}
                  textStyle={getStyle(screenSize, styles, 'buttonText')}
                />
                <CBSubmitButton
                  disabled={!edited}
                  onClick={this.handleSubmit}
                  text={t('save', { ns: 'common' })} />
              </div>
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    formContainer: {
      maxWidth: 800
    },
    container: {
      padding: 32,
      display: 'flex',
      flexDirection: 'column',
    },
    sectionContainer: {
      marginBottom: 16,
    },
    fieldContainer: {
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    input: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
    },
    buttonText: {
      fontSize: 14,
      fontWeight: 700,
      color: '#0095da',
      padding: 8,
      margin: 0,
    },
    button: {
      width: 200,
      border: '2px solid #0095da50',
      color: '#0095da',
      borderRadius: 50,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    inputLabelText: {
      color: 'black',
    },
  },
  medium: {
    container: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    workshops: state.workshop.workshops,
    loading: state.workshop.workshopListStatus.loading,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchWorkshops: _fetchWorkshops,
    updateWorkshop: _updateWorkshop,
  }
)(withRouter(translate('WSSettingsView')(WSPredictedMaintenanceSettings)));
